<template>
  <div id="center">
    <div class="up">
      <div class="bg-color-black item" :class="item.wide ? 'item-wide' : ''" v-for="item in titleItem" :key="item.title">
        <p v-if="!item.ms" class="ml-3 colorBlue fw-b" style="font-size:15px;margin-left:0">{{item.title}}</p>
        <div v-if="item.ms" class="ms-box">
          <div class="ms-col"><span class="ms-label">经验池</span><span class="ms-num">{{msExp}}</span></div>
          <div class="ms-col"><span class="ms-label">记忆数量</span><span class="ms-num">{{msMem}}</span></div>
        </div>
        <div v-else>
          <dv-digital-flop :config="item.number" style="width:96px;height:36px;" />
        </div>
      </div>
    </div>
    <div class="down">
      <div class="mid-row">
        <div class="left-col">
          <div class="ranking bg-color-black">
            <div class="rank-head">
              <span style="color:#5cd9e8">
                <icon name="align-left"></icon>
              </span>
              <span class="fs-xl text mx-2 mb-1">进程内存 TOP8</span>
            </div>
            <dv-scroll-ranking-board :config="ranking" class="rank-board" />
          </div>
        </div>
        <div class="percent">
          <div class="rose-item bg-color-black">
            <span class="rose-title">进程内存占比</span>
            <centerRoseChart :data="roseData" />
          </div>
        </div>
      </div>
      <dv-border-box-13 class="wave-frame">
        <div class="wave-row">
          <div class="wave-head">
            <span style="color:#5cd9e8">
              <icon name="chart-bar"></icon>
            </span>
            <span class="fs-xl text mx-2">{{waveTitle}}</span>
          </div>
          <div id="tokenChart" style="width:100%;height:52px;"></div>
        </div>
      </dv-border-box-13>
    </div>
  </div>
</template>

<script>
import centerRoseChart from "@/components/echart/center/centerRoseChart";
import { query, firstValue } from "@/api/prom";

const Q = {
  cpu: '100-(avg(rate(node_cpu_seconds_total{mode="idle"}[1m]))*100)',
  mem: "(1-node_memory_MemAvailable_bytes/node_memory_MemTotal_bytes)*100",
  disk: '(1-node_filesystem_avail_bytes{mountpoint="/"}/node_filesystem_size_bytes{mountpoint="/"})*100',
  ct: "gv_container_total",
  pod: "gv_pod_total",
  svc: "gv_service_total",
  bad: "gv_pod_notrunning",
  ds: "deepseek_balance_total"
};

export default {
  data() {
    return {
      pct: { cpu: 0, mem: 0, disk: 0 },
      lastVals: null,
      titleItem: [
        { title: "CPU 使用率", key: "cpu", number: { number: [0], toFixed: 1, content: "{nt}%" } },
        { title: "内存使用率", key: "mem", number: { number: [0], toFixed: 1, content: "{nt}%" } },
        { title: "磁盘使用率", key: "disk", number: { number: [0], toFixed: 1, content: "{nt}%" } },
        { title: "容器总数", key: "ct", number: { number: [0], toFixed: 0, content: "{nt}" } },
        { title: "Pod 总数", key: "pod", number: { number: [0], toFixed: 0, content: "{nt}" } },
        { title: "服务总数", key: "svc", number: { number: [0], toFixed: 0, content: "{nt}" } },
        { title: "经验池 / 记忆数量", key: "ms", ms: true, wide: true }
      ],
      roseData: [],
      ranking: {
        data: [],
        waitTime: 3000,
        // "single" 逐行滑动：始终显示 5 行
        carousel: "single",
        unit: "%"
      },
      tokenChart: null,
      waveTitle: "Token管家系统 压缩率趋势",
      msMem: "…",
      msExp: "…"
    };
  },
  components: {
    centerRoseChart
  },
  mounted() {
    this.refresh();
    this.timer = setInterval(this.refresh, 10000);
    this.refreshMemstats();
    this.msTimer = setInterval(this.refreshMemstats, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.msTimer);
    if (this.tokenChart) {
      this.tokenChart.dispose();
      this.tokenChart = null;
    }
  },
  methods: {
    async refresh() {
      const vals = {};
      await Promise.all(
        Object.keys(Q).map(async k => {
          const v = await firstValue(Q[k]);
          vals[k] = v == null ? (this.lastVals ? this.lastVals[k] : 0) : v;
        })
      );
      this.lastVals = vals;
      const num = k => (vals[k] == null ? 0 : parseFloat(vals[k].toFixed(1)));
      const int = k => (vals[k] == null ? 0 : Math.round(vals[k]));

      // 6 个核心数字
      const cpu = num("cpu"), mem = num("mem"), disk = num("disk");
      this.pct = { cpu, mem, disk };
      this.titleItem[0].number = { ...this.titleItem[0].number, number: [cpu] };
      this.titleItem[1].number = { ...this.titleItem[1].number, number: [mem] };
      this.titleItem[2].number = { ...this.titleItem[2].number, number: [disk] };
      this.titleItem[3].number = { ...this.titleItem[3].number, number: [int("ct")] };
      this.titleItem[4].number = { ...this.titleItem[4].number, number: [int("pod")] };
      this.titleItem[5].number = { ...this.titleItem[5].number, number: [int("svc")] };

      // Token 管家：真实数据来自 /live/api/usage（usage-events 归档聚合）
      this.refreshToken();

      // 排行榜 = 进程内存 TOP8
      const procs = await query(
        'gv_top_process{list="mem"}'
      );
      if (procs.length) {
        const rows = procs
          .map(p => ({
            name: String(p.metric.cmd || "?").slice(0, 16),
            value: parseFloat(p.value[1])
          }))
          .sort((a, b) => b.value - a.value)
          .slice(0, 8);
        this.ranking = { ...this.ranking, data: rows };
        // 玫瑰图 = 同一份进程内存占比数据
        this.roseData = rows.map(r => ({ ...r, name: r.name.slice(0, 9) }));
      }
    },
    // Token 管家系统综合压缩率（24h 全链路）：基数 18.7 万（改造前每轮平均注入量，实测基准常量），
    // 综合压缩率 = 1 − (24h 实际注入量 ÷ (187000 × 24h 调用次数))，把去重+摘要压缩+注入管理
    // 全链路省下的都算进「改造前基准 vs 实际」差异里；数据来自 /live/api/usage 的 totals.compressRate24h
    async refreshToken() {
      try {
        const r = await fetch("/live/api/usage?gran=15min&range=24h", { cache: "no-store" });
        if (!r.ok) return;
        const j = await r.json();
        const t = j.totals;
        if (!t) return;
        if (t.compressRate24h != null) {
          const rate = t.compressRate24h;
          this.waveTitle = "Token管家系统 24小时基准注入" + (t.baseTotal / 10000).toFixed(0) + "万 实际注入" + (t.injectedTotal / 10000).toFixed(0) + "万 压缩率为" + rate.toFixed(1) + "%";
        } else {
          this.waveTitle = "Token管家系统 压缩率趋势";
        }
        this.drawTokenChart(j.buckets || []);
      } catch (e) {
        console.warn("token chart fail:", e.message);
      }
    },
    async refreshMemstats() {
      try {
        const r = await fetch("/live/api/memstats", { cache: "no-store" });
        if (!r.ok) return;
        const j = await r.json();
        if (j.mem != null) this.msMem = j.mem.toLocaleString("en-US");
        if (j.exp != null) this.msExp = j.exp.toLocaleString("en-US");
      } catch (e) {
        console.warn("memstats fail:", e.message);
      }
    },
    drawTokenChart(bs) {
      if (!bs || !bs.length) return;
      if (!this.tokenChart) {
        const echarts = require("echarts");
        this.tokenChart = echarts.init(document.getElementById("tokenChart"));
      }
      const fmt = ts => {
        const d = new Date(ts);
        const p = x => (x < 10 ? "0" + x : "" + x);
        return p(d.getMonth() + 1) + "-" + p(d.getDate()) + " " + p(d.getHours()) + ":" + p(d.getMinutes());
      };
      // 综合压缩率口径（与卡片一致）：每桶综合压缩率 = 1 − (桶内实际注入量 ÷ (187000 × 桶内调用次数))
      // 桶内 sumInput = 该桶所有调用实际注入量之和；count=0（无数据）桶跳过
      const BASE_INJECT = 187000;
      const rateOf = b => {
        if (!b || b.sumInput == null) return null;
        if (!b.count) return 0; // 无数据桶画 0% 平线（避免 ECharts 断线缺口）
        const base = BASE_INJECT * b.count;
        const r = (1 - b.sumInput / base) * 100;
        return Math.max(0, Math.min(100, Math.round(r * 10) / 10));
      };
      const echarts = require("echarts");
      this.tokenChart.setOption(
        {
          animation: false,
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(8,12,28,0.92)",
            borderColor: "#2e4a8a",
            textStyle: { color: "#c3cbde", fontSize: 11 },
            axisPointer: { type: "shadow", shadowStyle: { color: "rgba(80,227,194,0.10)" } },
            formatter: ps => {
              if (!ps || !ps.length) return "";
              const p = ps[0];
              const b = bs[p.dataIndex];
              if (b.sumInput == null || !b.count) return fmt(b.ts) + "<br/>暂无数据";
              return fmt(b.ts) + "<br/>综合压缩率 " + rateOf(b).toFixed(1) + "%<br/>注入 " + (b.sumInput / 10000).toFixed(1) + " 万 / " + b.count + " 次";
            }
          },
          grid: { left: 0, right: 0, top: 2, bottom: 0 },
          xAxis: { type: "category", data: bs.map(b => fmt(b.ts)), show: false },
          yAxis: { type: "value", show: false, min: 0, max: 100 },
          series: [
            {
              name: "压缩率",
              type: "line",
              smooth: true,
              symbol: "none",
              data: bs.map(rateOf),
              lineStyle: {
                width: 2,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: "#7ef7d4" },
                  { offset: 0.5, color: "#38bdf8" },
                  { offset: 1, color: "#1d4ed8" }
                ]),
                shadowBlur: 6,
                shadowColor: "rgba(56,189,248,0.45)"
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(56,189,248,0.30)" },
                  { offset: 1, color: "rgba(29,78,216,0.03)" }
                ])
              }
            }
          ]
        },
        true
      );
    }
  }
};
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  height: 100%; /* 撑满 720px 网格行：wave 底部与右侧端口模块底部对齐 */
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 5px;
      margin-top: 0.4rem;
      width: 24%;
      height: 110px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center; /* 数字上下居中 */
    }
    .item-wide {
      width: 48%;
    }
    .ms-box {
      display: inline-flex;
      align-items: center;
      gap: 46px; /* gv-5px-extra-spacing: 两列再各外移5px(间距36→46, 中心距+10px设计值), 防数字涨到千万级相碰 */
      .ms-col {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        .ms-label {
          font-size: 15px; /* gv-label-style-align: 字号对齐左侧卡片标题(15px) */
          color: #257dff; /* gv-label-style-align: 颜色对齐左侧卡片标题(colorBlue #257dff) */
          font-weight: bold; /* gv-label-fix-bold: 粗细对齐左侧卡片标题(fw-b bold) */
          margin-bottom: 4px;
        }
        .ms-num {
          font-size: 22px;
          font-weight: 700;
          color: #33cea0;
        }
      }
    }
    .item-wide .tk-box {
      /* 2026-08-22 gv-tkoffset：压缩率卡片内容整体下移 20px（大哥反馈贴卡片边缘线） */
      transform: translateY(20px);
    }
    .tk-box {
      text-align: center;
      .tk-num {
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        color: #33cea0;
        &.ok { color: #33cea0; }
        &.warn { color: #facc15; }
        &.bad { color: #ff5722; }
      }
      .tk-sub {
        font-size: 12px;
        color: #8a94b8;
        line-height: 16px;
      }
    }
  }
  .down {
    padding: 4px;
    padding-bottom: 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1; /* 自动填充：上排下移、wave 底部对齐端口模块底部 */
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .mid-row {
      width: 100%;
      height: 316px; /* 拉长：TOP8+玫瑰图更高（260→316，+56px） */
      margin-top: 16px; /* 收小：上下缝隙 48/49.6 → ~20/~22 */
      display: flex;
      justify-content: space-between;
      .left-col {
        width: 58%;
        display: flex;
        flex-direction: column;
        .ranking {
          padding: 8px;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
        }
        .rank-head {
          display: flex;
          align-items: center;
        }
        .rank-board {
          flex: 1;
          min-height: 0;
        }
      }
      .percent {
        width: 40%;
        display: flex;
        .rose-item {
          margin: 0;
          width: 100%;
          height: 100%;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          .rose-title {
            color: #c3cbde;
            font-size: 14px;
            padding: 8px 0 0 10px;
          }
        }
      }
    }
    /* Token 压缩率条形图：横跨整行（TOP8 左端 → 玫瑰图右端），长宽比约 5:1，API 调用量同款外框 */
    .wave-frame {
      width: 100%;
      height: 101px; /* gv-annotated-fix：波形高度压到 3/5 后收窄外框 */
    }
    .wave-row {
      width: 100%;
      height: 100%;
      padding: 6px 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .wave-head {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        padding: 15px 0 1px 0; /* gv-annotated-fix：标题文字下移 15px */
        .text {
          color: #c3cbde;
          font-size: 14px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
/* 手机端可读性：排名板字号上调（覆盖组件默认 13px） */
.dv-scroll-ranking-board .ranking-info {
  font-size: 14px;
}
.dv-scroll-ranking-board .ranking-column {
  margin-top: 1px;
}
.dv-scroll-ranking-board .ranking-column .inside-column {
  height: 4px;
  margin-bottom: 0;
}
/* 行间距均分：禁用行折叠过渡动画（中间帧会出现 0/半高行，视觉行距不均） */
.dv-scroll-ranking-board .row-item {
  transition: none !important;
}
</style>
